import React, { useState } from 'react';

import { useHistory, useLocation } from 'react-router';

import {
  AccountQueryParamFilters,
  AccountQueryParams,
  filterAccountsByQueryParams,
  validateAccountQueryParams,
} from '../admin/components/pending-admin-action-tabs/account-query-param-filters';
import { AccountTablePagination } from '../admin/components/pending-admin-action-tabs/account-table-pagination';

import { homePageLandingRedirectRoute } from '../web-routes';

import { AccountsListTable, AccountsListTableProps } from './accounts-list-table';

export const AccountsListTableWithControls = ({
  accounts,
  ...restOfAccountsListTableProps
}: AccountsListTableProps) => {
  const history = useHistory();
  const { search } = useLocation();
  const queryParams = validateAccountQueryParams(search);

  const [offset, setOffset] = useState(0);

  const handleOffsetChange = (newOffset: number) => {
    setOffset(newOffset);
  };

  const navigateWithQueryStringParams = (updatedQueryParams: AccountQueryParams) => {
    history.replace(homePageLandingRedirectRoute(updatedQueryParams));
  };

  const filteredAccounts = filterAccountsByQueryParams(queryParams, accounts);

  return (
    <div className="card u-margin-top-xl">
      <div className="card-body">
        <div className="u-spread u-padding u-no-padding-bottom">
          <div className="u-display-flex u-flexWrap-wrap">
            <AccountQueryParamFilters
              navigateWithQueryStringParams={navigateWithQueryStringParams}
            />
          </div>
          <AccountTablePagination
            count={filteredAccounts.length}
            offset={offset}
            handleOffsetChange={handleOffsetChange}
          />
        </div>
        <AccountsListTable
          accounts={filteredAccounts}
          paginationOffset={offset}
          {...restOfAccountsListTableProps}
        />
        <AccountTablePagination
          count={filteredAccounts.length}
          offset={offset}
          handleOffsetChange={handleOffsetChange}
        />
      </div>
    </div>
  );
};
